'use client'
import {
  IMAGE_QUERY
} from "./chunk-AFUSNP5S.mjs";

// src/api/queries/location.ts
var LOCATION_QUERY = `
title
address
city
countryCode
seactionHeader
googlePlaceName
location { lat lon }
banner {${IMAGE_QUERY}}
accessibility
`;

export {
  LOCATION_QUERY
};
//# sourceMappingURL=chunk-RJD7S7WV.mjs.map